import React from 'react';
import styled from 'styled-components';
import { AnimatedLoadingPlaceholder } from '../../../../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';

interface CardSectionTextLoadingUIProps {
    dayNightLabel: string;
}

export const CardSectionTextLoadingUI = ({ dayNightLabel }: CardSectionTextLoadingUIProps) => {
    return (
        <Container>
            <CardSectionDayLabel>{dayNightLabel}</CardSectionDayLabel>
            <TemperatureReading>
                <AnimatedLoadingPlaceholder height='100%' width={36} />
            </TemperatureReading>
            <CardSectionDescription>
                <AnimatedLoadingPlaceholder height='100%' />
            </CardSectionDescription>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: calc(100% - 55px);
    padding-right: 6px;
    line-height: 1.1;
`;

const CardSectionDayLabel = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    font-size: 13px;
    font-weight: 600;
    text-transform: uppercase;
    color: #aaa;
`;

const TemperatureReading = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 37px;
`;

const CardSectionDescription = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 15px;
    white-space: normal;
`;